<template>
  <div class="trace-inquiry">
    <el-tabs tab-position="bottom">
      <el-tab-pane label="产品信息">
        <template v-if="productImgs.length === 0">
          <div class="imgNull">暂无产品图片</div>
        </template>
        <template v-if="productImgs.length === 1">
          <img class="imgOne" :src="productImgs[0]" alt="">
        </template>
        <template v-if="productImgs.length > 1">
          <el-carousel trigger="click" arrow="never">
            <el-carousel-item v-for="(item, index) in productImgs" :key="index">
              <img class="product-img" :src="productImgs[index]" alt="">
            </el-carousel-item>
          </el-carousel>
        </template>
        <div class="item1-text">
          <p>您查询的溯源码为</p>
          <p>{{ traceCode }}</p>
          <p>此码已核实是由{{ productData.orgName }}公司出品的产品</p>
          <p>感谢您的购买</p>
        </div>
        <div class="item1-list">
          <ul>
            <li>
              <span>产品名称：</span>
              <span>{{ productData.productName }}</span>
            </li>
            <li>
              <span>商品条码：</span>
              <span>{{ barCode }}</span>
            </li>
            <li>
              <span>批次编码：</span>
              <span>{{ batchCode }}</span>
            </li>
            <li>
              <span>商标：</span>
              <span>{{ productData.productTrademark }}</span>
            </li>
            <li>
              <span>保质期：</span>
              <span>{{ productData.shelfLife }}</span>
            </li>
          </ul>
        </div>
      </el-tab-pane>
      <el-tab-pane label="种植信息">
        <h2 class="h-title">种植信息</h2>
        <el-timeline style="padding:10vw;">
          <el-timeline-item
            v-for="item in materialuseinfoData"
            :key="item.id"
            type="primary"
            color="#409EFF"
            size="large"
            timestamp
            placement="center"
            style="line-height:22px"
          >
            <el-card>
              {{ item.title }}<br>
              描述信息：{{ item.description }}<br>
              负责人：{{ item.manager }}<br>
              日期：{{ item.operDate | formatDate }}<br>
              <template v-for="material in item.list">
                用料名称：{{ material.materialName }}
              </template>
              <template v-if="item.imgUrl">
                <img style="width:100%;" :src="item.imgUrl" alt="">
              </template>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-tab-pane>
      <el-tab-pane label="检验信息">
        <h2 class="h-title">检验信息</h2>
        <div class="controlpoint-item" v-for="(item) in checkData" :key="item.id">
          <ul>
            <li>
              <span>检验项名称：</span>
              <p>{{ item.checkReportName }}</p>
            </li>
            <li>
              <span>报告名称：</span>
              <p>{{ item.checkReportName }}</p>
            </li>
            <li>
              <span>检验单位：</span>
              <p>{{ item.checkOrg }}</p>
            </li>
            <li>
              <span>检验值：</span>
              <p>{{ item.checkVal }}</p>
            </li>
            <li>
              <span>参考值：</span>
              <p>{{ item.referenceVal }}</p>
            </li>
            <li>
              <span>检验时间：</span>
              <p>{{ item.checkDate | formatDate }}</p>
            </li>
            <li>
              <span>负责人：</span>
              <p>{{ item.manager }}</p>
            </li>
            <li>
              <span>报告结论：</span>
              <p v-if="item.checkResult === 1">合格</p>
              <p v-else>不合格</p>
            </li>
            <li>
              <template v-if="item.checkReportImg !== 'images' || !item.checkReportImg">
                <img style="width:100%;" :src="item.checkReportImgUrl" :alt="item.checkReportName">
              </template>
            </li>
          </ul>
        </div>
      </el-tab-pane>
      <el-tab-pane label="控制点信息">
        <h2 class="h-title">控制点信息</h2>
        <div class="controlpoint-item" v-for="(item, index) in controlpointData" :key="item.id">
          <ul>
            <li>
              <span>控制点名称{{ index + 1 }}：</span>
              <p>{{ item.controlPointName }}</p>
            </li>
            <li>
              <span>负责人：</span>
              <p>{{ item.manager }}</p>
            </li>
            <li>
              <span>开始时间：</span>
              <p>{{ item.startDate | formatDate }}</p>
            </li>
            <li>
              <span>结束时间：</span>
              <p>{{ item.endDate | formatDate }}</p>
            </li>
            <li>
              <span>监测结论：</span>
              <p v-if="item.isQualified === 1">合格</p>
              <p v-else>不合格</p>
            </li>
          </ul>
        </div>
      </el-tab-pane>
      <el-tab-pane label="产地简介">
        <h2 class="h-title">产地简介</h2>
        <div class="chandi" v-html="content"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import moment from 'moment'
import { getCheckDetail, getProductDetail, getControlpointDetail, getMaterialuseinfoDetail, getProductOrg, initBatchCode } from '@/api/qrcode'
export default {
  data() {
    return {
      traceCode: '',
      barCode: '',
      batchCode: '',
      productData: {},
      controlpointData: [],
      checkData: [],
      materialuseinfoData: [],
      productImgs: [],
      content: ''
    }
  },
  methods: {
    initBatchCodeData() {
      // 初始化溯源码、批次编码
      initBatchCode(this.traceCode).then(res => {
        // this.checkData = res.data
        this.barCode = res.data.barCode
        this.batchCode = res.data.batchCode
      })
    },
    // 获取产品详细信息
    getProductDetailData() {
      getProductDetail(this.barCode).then(res => {
        for (let i = 1; i < 6; i++) {
          if (res.data['imgUrl' + i]) {
            this.productImgs.push(res.data['imgUrl' + i])
          }
        }
        this.productData = res.data
      })
    },
    // 获取检查项详细信息
    getCheckDetailData() {
      getCheckDetail(this.batchCode).then(res => {
        this.checkData = res.data
      })
    },
    // 获取控制点信息
    getControlpointDetailData() {
      getControlpointDetail(this.batchCode).then(res => {
        this.controlpointData = res.data
      })
    },
    // 获取种植信息
    getMaterialuseinfoDetailData() {
      getMaterialuseinfoDetail(this.barCode).then(res => {
        this.materialuseinfoData = res.data
      })
    },
    // 获取企业详情
    getOrgDetail() {
      getProductOrg(this.barCode).then(res => {
        this.content = res.data.content
      })
    }
  },
  created() {
    this.traceCode = this.$route.query.t
    // this.barCode = this.$route.query.p
    // this.batchCode = this.$route.query.b

    // 初始化溯源码、批次编码
    initBatchCode(this.traceCode).then(res => {
      // this.checkData = res.data
      this.barCode = res.data.barcode
      this.batchCode = res.data.batchCode

      this.getCheckDetailData()
      this.getProductDetailData()
      this.getControlpointDetailData()
      this.getMaterialuseinfoDetailData()
      this.getOrgDetail()
    })
    // this.initBatchCodeData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
html,body {
  width: 100%;
  height: 100%;
  font-size: 10vw;
  overflow-y: hidden;
  -webkit-overflow-scroll: auto;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
.trace-inquiry ::v-deep{
  .el-tabs__header.is-bottom {
    position: fixed;
    bottom: 0;
    background-color: #fff;
  }
  .el-tabs__item.is-active {
    border: solid 1px #409eff;
  }
  .el-tabs__nav-wrap {
    margin-bottom: 0;
  }
  .el-tabs__item {
    border: solid 1px #f5f5f5;
    border-left: none;
  }
  .el-carousel__container {
    height: 30vh;
  }
  .imgOne {
    height: 30vh;
    width: 100%;
  }
  .imgNull {
    background-color: #99a9bf;
    line-height: 30vh;
    height: 30vh;
    font-size: 2vh;
    text-align: center;
  }
  .el-carouselel-carousel {
    height: 30vh;
    .el-carousel__item {
      height: 30vh;
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 1vw;
    opacity: 0.75;
    line-height: 1.5vh;
    margin: 0;
  }
  .item1-text {
    text-align: center;
    line-height: 1.5rem;
    font-size: 1rem;
    padding: 2rem 0;
  }
  .item1-list li {
    line-height: 1.5rem;
    margin-bottom: 1rem;
    display: flex;
  }
  .item1-list li span:first-child {
    display: inline-block;
    width: 10rem;
    text-align: right;
  }
  .item1-list li span:last-child {
    display: inline-block;
    border-bottom: solid 1px #f5f5f5;
    width: 60%;
  }
  .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
  }
  .trace-inquiry {
    max-width: 100rem;
    margin: 0 auto;
    position: absolute;
    padding-bottom: 15vh;
    overflow-y: scroll;
    height: 100%;
  }
  .el-tabs {
    height: 100vh;
  }
  .controlpoint-item {
    border: solid 1px #ccc;
    margin: 5vw;
    font-size: 1rem;
    padding: 3vw 0;
  }
  .controlpoint-item li {
    padding: 1vw 5vw;
    display: flex;
    line-height: 1.6rem;
  }
  .controlpoint-item span {
    display: block;
    width: 35vw;
  }
  .controlpoint-item p {
    border-bottom: solid 1px #ccc;
    width: 55vw;
  }
  .h-title {
    font-size: 1rem;
    font-weight: bold;
    padding: 5vw 5vw 0 5vw;
  }
  .product-img {
    height: 30vh;
    width: 100%;
  }
  .el-tabs__content {
    height: 92vh;
    overflow-y: auto;
  }
  .el-tabs__header {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .el-tabs__nav {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .el-tabs__item {
      flex: 1;
      width: 20%;
      padding: 0;
      text-align: center;
      font-size: 0.9rem;
    }
  }
  .chandi {
    padding: 5vw;
    img {
      width: 100%;
    }
    p {
      font-size: 4vw;
      line-height: 6vw;
      padding: 2vw 0;
    }
  }
  .el-tabs__active-bar {
    display: none;
  }
}
</style>
